// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

Rails.start()
Turbolinks.start()
ActiveStorage.start()
// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);


/*!
* Start Bootstrap - SB Admin Pro v2.0.2 (https://shop.startbootstrap.com/product/sb-admin-pro)
* Copyright 2013-2021 Start Bootstrap
* Licensed under SEE_LICENSE (https://github.com/StartBootstrap/sb-admin-pro/blob/master/LICENSE)
*/

function number_format(number, decimals, dec_point, thousands_sep) {
    // *     example: number_format(1234.56, 2, ',', ' ');
    // *     return: '1 234,56'
    number = (number + "").replace(",", "").replace(" ", "");
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
        dec = typeof dec_point === "undefined" ? "." : dec_point,
        s = "",
        toFixedFix = function(n, prec) {
            var k = Math.pow(10, prec);
            return "" + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split(".");
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || "").length < prec) {
        s[1] = s[1] || "";
        s[1] += new Array(prec - s[1].length + 1).join("0");
    }
    return s.join(dec);
}

window.addEventListener('turbolinks:load', event => {
    $('#knowledgebase-helpful').click(function(e){
    e.preventDefault(); // add this line
    const csrfToken = document.querySelector("meta[name=csrf-token]").content;

    $.ajax({
      type: 'POST',
      url: "/documentation/helpful?knowledgebase_type=" + e.target.dataset.type + "&knowledgebase_id=" + e.target.dataset.id,
      success: function(response){
        $("#helpful-count").text(response.helpful);
        e.target.disabled = true
      },
      headers: { 'X-CSRF-Token': csrfToken}
    })
  });

  $('#knowledgebase-unhelpful').click(function(e){
    e.preventDefault(); // add this line
    const csrfToken = document.querySelector("meta[name=csrf-token]").content;
    $.ajax({
      type: 'POST',
      url: "/documentation/unhelpful?knowledgebase_type=" + e.target.dataset.type + "&knowledgebase_id=" + e.target.dataset.id,
      success: function(response){
        e.target.disabled = true
      },
      headers: { 'X-CSRF-Token': csrfToken}
    })
  });
  
  $('#knowledgebaseSearch').change(function(e){
    if (e.target.value != "") {
      window.location.href = "/documentation/search?q=" + encodeURIComponent(e.target.value);
    }
  });

  $(".switch input").change(function(event){
    const csrfToken = document.querySelector("meta[name=csrf-token]").content;
    var path = location.pathname + "/toggle?state="
    $.ajax({type: 'POST',
      url: path + event.target.checked,
      success: function( data ) {
        console.log("successful update rule state");
      },
      fail: function(data){
        console.log("failed update rule state");
      },
      headers: { 'X-CSRF-Token': csrfToken}
    });
  });

  $("#queues_queue_name").change(function(event){
    var drop_down = event.target;
    var url = new URL(window.location);
    var query_string = window.location.search;
    query_string = query_string === '' ? '?selected_queues=a' : query_string
    var query_params = query_string.substring(1).split("&");
    query_params = $.map(query_params, function(i){
      var pair = i.split("=");
      var key = pair[0];
      var value = pair[1];
      if (key == "selected_queues"){
        return key + "=" + encodeURIComponent(drop_down.value);
      } else {
        return key + "=" + value;
      }
    })
    window.location.href = url.origin + url.pathname + "?" + query_params.join("&");
  });


	// Activate feather
	feather.replace();

	// Enable tooltips globally
	var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
	var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
	    return new bootstrap.Tooltip(tooltipTriggerEl);
	});

	// Enable popovers globally
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
	    return new bootstrap.Popover(popoverTriggerEl);
	});

	// Activate Bootstrap scrollspy for the sticky nav component
	const navStick = document.body.querySelector('#navStick');
	if (navStick) {
	    new bootstrap.ScrollSpy(document.body, {
	        target: '#navStick',
	        offset: 82,
	    });
	}

	// Collapse Navbar
	// Add styling fallback for when a transparent background .navbar-marketing is scrolled
	var navbarCollapse = function() {
	    const navbarMarketingTransparentFixed = document.body.querySelector('.navbar-marketing');
	    if (!navbarMarketingTransparentFixed) {
	        return;
	    }
	    if (window.scrollY === 0) {
	        navbarMarketingTransparentFixed.classList.remove('navbar-scrolled')
	    } else {
	        navbarMarketingTransparentFixed.classList.add('navbar-scrolled')
	    }

	};
	// Collapse now if page is not at top
	navbarCollapse();
	// Collapse the navbar when page is scrolled
	document.addEventListener('scroll', navbarCollapse);

    // Toggle the side navigation
    const sidebarToggle = document.body.querySelector('#sidebarToggle');
    if (sidebarToggle) {
        // Uncomment Below to persist sidebar toggle between refreshes
        // if (localStorage.getItem('sb|sidebar-toggle') === 'true') {
        //     document.body.classList.toggle('sidenav-toggled');
        // }
        sidebarToggle.addEventListener('click', event => {
            event.preventDefault();
            document.body.classList.toggle('sidenav-toggled');
            localStorage.setItem('sb|sidebar-toggle', document.body.classList.contains('sidenav-toggled'));
        });
    }

    // Close side navigation when width < LG
    const sidenavContent = document.body.querySelector('#layoutSidenav_content');
    if (sidenavContent) {
        sidenavContent.addEventListener('click', event => {
            const BOOTSTRAP_LG_WIDTH = 992;
            if (window.innerWidth >= 992) {
                return;
            }
            if (document.body.classList.contains("sidenav-toggled")) {
                document.body.classList.toggle("sidenav-toggled");
            }
        });
    }

    // Add active state to sidbar nav links
    let activatedPath = window.location.pathname.match(/([\w-]+)/, '$1');

    if (activatedPath) {
        activatedPath = activatedPath[0];
    } else {
        activatedPath = 'index.html';
    }

    const targetAnchors = document.body.querySelectorAll('[href="' + activatedPath + '"].nav-link');

    targetAnchors.forEach(targetAnchor => {
        targetAnchor.classList.add('active');
    });

function date_format(date, show_date) {
    const point_date = new Date(date);
    if (show_date) {
        return point_date.toLocaleDateString() + ' ' + point_date.toLocaleTimeString();
    } else {
        return point_date.toLocaleTimeString();
    }        
}

function is_different_day(date1, date2) {
    //Assumes dates would be within the same or adjacent months
    return date1.toLocaleDateString() != date2.toLocaleDateString();
}

var leftEnd;
var rightEnd;

function updateChart() {
    var chartId = "queue_time_chart";
    Chart.helpers.each([myDynoChart,myLineChart], function (instance) {
        instance.options.scales.x.min = leftEnd;
        instance.options.scales.x.max = rightEnd; 

        if(chartId == instance.canvas.id){
            var eventArea = {
                type: 'line',
                scaleID: 'y',
                borderWidth: 3,
                borderColor: 'black',
                value: 200,
            };
          //instance.options.annotation.annotations.push(eventArea);
        }

        instance.update();
    });
}

function annotations(upscaleannotations_data, downannotations_data){
    var a_obj = {};
    var line_count = 0;
    $.each(upscaleannotations_data, function(i, a){
      line_count += 1;
      var t_obj = {};
      t_obj["line" + line_count] = {
          type: 'line',
          borderDash: [5, 5],
          yMin: a.yMin,
          yMax: a.yMax,
          xMin: a.xMin,
          xMax: a.xMax,
          borderColor: 'rgb(255, 99, 132)',
          borderWidth: 2,
        }

      $.extend(a_obj, t_obj);
    });
    $.each(downannotations_data, function(i, a){
      line_count += 1;
      var t_obj = {};
      t_obj["line" + line_count] = {
          type: 'line',
          borderDash: [5, 5],
          yMin: a.yMin,
          yMax: a.yMax,
          xMin: a.xMin,
          xMax: a.xMax,
          borderColor: 'rgb(94, 97, 223)',
          borderWidth: 2,
        }
      
      $.extend(a_obj, t_obj);
    });
    return a_obj;
}

// Area Chart Example
var ctx = document.getElementById("queue_time_chart");
if (ctx){

const measurement_data = JSON.parse(window.atob(unescape(encodeURIComponent(ctx.dataset.measurements))));
var labels = [];
var chart_data = [];
var date_cache = [];
$.each(measurement_data, function(i, a){
  date_cache.push(new Date(a.measured_at));
  labels.push(a.measured_at);
});
$.each(measurement_data, function(i, a){
  chart_data.push(a.duration);
});

const upscaleannotations_data = JSON.parse(window.atob(unescape(encodeURIComponent(ctx.dataset.upscaleannotations))));
const downscaleannotations_data = JSON.parse(window.atob(unescape(encodeURIComponent(ctx.dataset.downscaleannotations))));
var myLineChart = new Chart(ctx, {
    type: "line",
    data: {
      labels: labels,
      datasets: [{
        label: 'Queued Time',
        pointRadius: 0,
        data: chart_data,
        borderColor: 'rgb(123, 123, 123)',
        borderWidth: 1,
      }]
    },
    options: {
        maintainAspectRatio: false,
        layout: {
            padding: {
                left: 10,
                right: 25,
                top: 25,
                bottom: 0
            }
        },
        scales: {
            y: {
                ticks: {
                    // Include a dollar sign in the ticks
                    callback: function(value, index, values) {
                        return number_format(value) + " ms";
                    }
                }
            },
            x: {
                grid: {
                    display: false
                },
                ticks: {
                    maxRotation: 0,
                    autoSkip: false,
                    stepSize:50,
                    callback: function(value, index, values) {

                        var right = rightEnd || values.length - 1;
                        var left  = leftEnd || 0;
                        var start_time = date_cache[left];
                        var end_time   = date_cache[right];
                        var diff = (end_time - start_time) / 1000;

                        var tick_time = new Date(date_cache[index]);

                        if (diff >= 43200){ // 12 hours
                          if (tick_time.getHours() % 2 == 0 && tick_time.getMinutes() == 0 && tick_time.getSeconds() == 0){
                            return date_format(this.getLabelForValue(value), false);
                          }
                        } else if (diff >= 21600){ // 6 hours
                          if ((tick_time.getMinutes() == 0) && tick_time.getSeconds() == 0){
                            return date_format(this.getLabelForValue(value), false);
                          }
                        } else if (diff >= 10800 ){ // 3 hours
                          if ((tick_time.getMinutes() == 0 || tick_time.getMinutes() == 30) && tick_time.getSeconds() == 0){
                            return date_format(this.getLabelForValue(value), false);
                          }
                        } else if (diff >= 3600 ){ // 1 hour
                          if ((tick_time.getMinutes() % 10 == 0) && tick_time.getSeconds() == 0){
                            return date_format(this.getLabelForValue(value), false);
                          }
                        } else if (diff >= 1800 ){ // 30 min
                          if ((tick_time.getMinutes() & 5 == 0) && tick_time.getSeconds() == 0){
                            return date_format(this.getLabelForValue(value), false);
                          }
                        } else if (diff >= 600 ){ // 10 min
                          if ((tick_time.getMinutes() % 2 == 0) && tick_time.getSeconds() == 0){
                            return date_format(this.getLabelForValue(value), false);
                          }
                        } else if (diff >= 300 ){ // 5 min
                          if (tick_time.getSeconds() % 30 == 0){
                            return date_format(this.getLabelForValue(value), false);
                          }
                        } else if (diff >= 60 ){ // 1 min
                          if (tick_time.getSeconds() % 20 == 0 ){
                            return date_format(this.getLabelForValue(value), false);
                          }
                        } else if (diff >= 0 ){ // 0 min
                          if (tick_time.getSeconds() % 10 == 0 ){
                            return date_format(this.getLabelForValue(value), false);
                          }
                        }
                        return '';
                        
                    }
                }
            }
        },
        legend: {
            display: false
        },
        plugins: {
          zoom: {
            limits: {
              x: {min: 'original', max: 'original'},
              y: {min: 'original', max: 'original'},
            },
            pan: {
              enabled: true,
              mode: 'x',
              modifierKey: 'ctrl',
            },
            zoom: {
              wheel: {
                enabled: true,
              },
              drag: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
              onZoom: function () {
                  leftEnd = myLineChart.options.scales.x.min
                  rightEnd = myLineChart.options.scales.x.max

                  updateChart()
              }
            }
          },
          tooltip: {
            callbacks: {
                title: function(context) {
                    var datasetLabel = date_format(new Date(context[0].label), true) || "";
                    return datasetLabel;
                },
                label: function(context) {
                  if (measurement_data[context.dataIndex].tooltip_override){
                    return measurement_data[context.dataIndex].tooltip_override;
                  } else {
                    return "Queue Time: " + context.dataset.data[context.dataIndex];
                  }
                }
            }
          },
          legend: {
            display: false
          },
          annotation: {
            annotations: annotations(upscaleannotations_data, downscaleannotations_data)
          }
        }
    }
});

/*function doPoll(){
    var has_data = myLineChart.data.datasets[0].data.length > 0
    var start_date = myLineChart.data.labels[myLineChart.data.labels.length-1]
    var params = has_data ? '?start_date=' + start_date : ''
    $.get('chart_data' + params, function(data) {
        //myLineChart.data.datasets[0].data = data['measurements'];
        $.each(data['measurements'], function(val) {
          addQueueTimeData(myLineChart, this['duration'],this['measured_at'])
          addAutoScaleData(myDynoChart, this['dyno_count'], this['measured_at'])
        });
        myLineChart.update();
        myDynoChart.update();
    	
        setTimeout(doPoll,30000);
    });
}
doPoll();
var date_cache = [];
function addQueueTimeData(chart, data, label) {
    chart.data.labels.push(label);
    date_cache.push(new Date(data))
    // Queue Time 
    chart.data.datasets[0].data.push(data);
}
function addAutoScaleData(chart, data, label) {
    // Autoscale Events
    chart.data.labels.push(label);
    chart.data.datasets[0].data.push(data);
}*/
// Area Chart Example

var ctx = document.getElementById("autoscale_chart");
const dyno_data = JSON.parse(window.atob(unescape(encodeURIComponent(ctx.dataset.dynocount))));
var labels = [];
var chart_data = [];
var dyno_type_data = [];
var datasets = [];

$.each(Object.keys(dyno_data), function(i,b){
  var formation_dyno_data = dyno_data[b];
  $.each(formation_dyno_data, function(i, a){
    labels.push(a.measured_at);
    dyno_type_data.push(a.dyno_size);
    chart_data.push({x: a.measured_at, y: a.dyno_count, type: a.dyno_size});
  });

  datasets.push({
    label: "Dyno Count - " + b,
    pointRadius: 2,
    data: chart_data,
    borderColor: 'rgb(123, 123, 123)',
    borderWidth: 1,
  });

  labels = [];
  dyno_type_data = [];
  chart_data = [];
});

var myDynoChart = new Chart(ctx, {
    type: "line",
    data: {
      labels: labels,
      datasets: datasets
    },
    options: {
        maintainAspectRatio: false,
        layout: {
            padding: {
                left: 10,
                right: 25,
                top: 25,
                bottom: 0
            }
        },
        scales: {
            y: {
                afterSetDimensions: function(axis){
                  axis.paddingLeft = myLineChart.chartArea.left;
                  return;
                },
                ticks: {
                    // Include a dollar sign in the ticks
                    callback: function(value, index, values) {
                        return number_format(value);
                    },
                    stepSize:1,
                },
                min: 0,
            },
            x: {
                grid: {
                    display: false
                },
                ticks: {
                    maxRotation: 0,
                    autoSkip: false,
                    stepSize:50,
                    callback: function(value, index, values) {

                        var right = rightEnd || values.length - 1;
                        var left  = leftEnd || 0;
                        var start_time = date_cache[left];
                        var end_time   = date_cache[right];
                        var diff = (end_time - start_time) / 1000;

                        var tick_time = new Date(date_cache[index]);

                        if (diff >= 43200){ // 12 hours
                          if (tick_time.getHours() % 2 == 0 && tick_time.getMinutes() == 0 && tick_time.getSeconds() == 0){
                            return date_format(this.getLabelForValue(value), false);
                          }
                        } else if (diff >= 21600){ // 6 hours
                          if ((tick_time.getMinutes() == 0) && tick_time.getSeconds() == 0){
                            return date_format(this.getLabelForValue(value), false);
                          }
                        } else if (diff >= 10800 ){ // 3 hours
                          if ((tick_time.getMinutes() == 0 || tick_time.getMinutes() == 30) && tick_time.getSeconds() == 0){
                            return date_format(this.getLabelForValue(value), false);
                          }
                        } else if (diff >= 3600 ){ // 1 hour
                          if ((tick_time.getMinutes() % 10 == 0) && tick_time.getSeconds() == 0){
                            return date_format(this.getLabelForValue(value), false);
                          }
                        } else if (diff >= 1800 ){ // 30 min
                          if ((tick_time.getMinutes() & 5 == 0) && tick_time.getSeconds() == 0){
                            return date_format(this.getLabelForValue(value), false);
                          }
                        } else if (diff >= 600 ){ // 10 min
                          if ((tick_time.getMinutes() % 2 == 0) && tick_time.getSeconds() == 0){
                            return date_format(this.getLabelForValue(value), false);
                          }
                        } else if (diff >= 300 ){ // 5 min
                          if (tick_time.getSeconds() % 30 == 0){
                            return date_format(this.getLabelForValue(value), false);
                          }
                        } else if (diff >= 60 ){ // 1 min
                          if (tick_time.getSeconds() % 20 == 0 ){
                            return date_format(this.getLabelForValue(value), false);
                          }
                        } else if (diff >= 0 ){ // 0 min
                          if (tick_time.getSeconds() % 10 == 0 ){
                            return date_format(this.getLabelForValue(value), false);
                          }
                        }
                        return '';
                        
                    }
                }
            }
        },
        legend: {
            display: false
        },
        plugins: {
          zoom:{
            limits: {
              x: {min: 'original', max: 'original'},
              y: {min: 'original', max: 'original'},
            },
            pan: {
              enabled: true,
              mode: 'x',
              modifierKey: 'ctrl',
            },
            zoom: {
              wheel: {
                enabled: true,
              },
              drag: {
                enabled: true,
              },
              pinch: {
                enabled: true
              },
              mode: 'x',
              onZoom: function () {
                  leftEnd = myDynoChart.options.scales.x.min
                  rightEnd = myDynoChart.options.scales.x.max
                  updateChart()
              }
            }
          },
          tooltip: {
            callbacks: {
                title: function(context) {
                    var datasetLabel = date_format(new Date(context[0].label), true) || "";
                    return datasetLabel;
                },
                afterTitle: function(context){
                  return 'Dyno Size: ' + context[0].raw.type;
                }
            }
          },
          legend: {
            display: false
          },
          annotation: {

          }
        }
    }
});
  var reset_zoom_btn = document.getElementById("reset_zoom_btn");
  reset_zoom_btn.addEventListener("click", function(){
    leftEnd = 0;
    rightEnd = chart_data.length - 1;
    updateChart();
  });
}
});

window.addEventListener('turbolinks:load', event => {

var s_ctx = document.getElementById("savings_chart")
if (s_ctx) {
const savings_data = JSON.parse(window.atob(unescape(encodeURIComponent(s_ctx.dataset.savingsdata))));
var labels = [];
var chart_data = [];
var date_cache = [];
$.each(savings_data, function(i, a){
  date_cache.push(new Date(a.date));
  chart_data.push(a.sum);
  labels.push(a.date);
});
///////////
var mySavingsChart = new Chart(s_ctx, {
    type: "line",
    data: {
      labels: labels,
      datasets: [{
        label: 'Daily Savings',
        pointRadius: 2,
        data: chart_data,
        borderColor: 'rgb(123, 123, 123)',
        borderWidth: 1,
      }]
    },
    options: {
        maintainAspectRatio: false,
        layout: {
            padding: {
                left: 10,
                right: 25,
                top: 25,
                bottom: 0
            }
        },
        scales: {
            y: {
                ticks: {
                    beginAtZero: true,
                    callback: function(value, index, values) {
                        return "$" + number_format(value, 2);
                    },
                    stepSize:1,
                },
                min: 0,
            },
            x: {
                grid: {
                    display: false
                },
                ticks: {
                    maxRotation: 90,
                    autoSkip: false,
                    stepSize:50,
                }
            }
        },
        legend: {
            display: false
        },
        plugins: {
          tooltip: {
            callbacks: {
              label: function(context){
                return 'Daily Savings: $' + number_format(context.formattedValue, 2);
              }
            }
          },
          legend: {
            display: false
          },
          annotation: {

          }
        }
    }
});
}
});
///////////
